import { FontSizeVals, HeightVals, SpaceVals } from '../../enhancers';

export const sizes: Partial<Record<HeightVals, { height: SpaceVals; width: SpaceVals; fontSize: FontSizeVals }>> = {
  lg: { width: 12, height: 6, fontSize: 'lg' },
  md: { width: 10, height: 5, fontSize: 'sm' },
  sm: { width: 8, height: 4, fontSize: '2xs' },
};
